module.exports = __webpack_public_path__ + "d75b1bd1348efe5757db9f1fd80e9df6.jpg";